// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__UZ4jS","spinner-border":"LoadingSpinner_spinner-border__1SbHS"};